import { Component, Mixins, Prop } from 'vue-property-decorator';
import addHighDemandSuggestionMutation from '../../mutations/addHighDemandSuggestion';
import highDemandSuggestionsQuery from '../../queries/highDemandSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListHighDemandAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly query = highDemandSuggestionsQuery;

  public readonly mutation = addHighDemandSuggestionMutation;

  public mutationVariables(suggestionCandidate: any) {
    return {
      suggestionsListId: this.suggestionsList.id,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      bookings: suggestionCandidate.source.bookings,
      maxSimultaneous: suggestionCandidate.source.maxSimultaneous,
    };
  }
}
